import { createContext, useContext, useMemo } from "react";
import { useGetProfile } from "@workspace/api-client-react";
import { getRegionTerms, type RegionTerms } from "@/lib/region-config";

interface RegionContextValue {
  terms: RegionTerms;
  region: string;
  schoolName: string | null;
  reportHeader: string | null;
  reportFooter: string | null;
  dateFormat: string;
  isLoading: boolean;
}

const RegionContext = createContext<RegionContextValue>({
  terms: getRegionTerms("au"),
  region: "au",
  schoolName: null,
  reportHeader: null,
  reportFooter: null,
  dateFormat: "dd/MM/yyyy",
  isLoading: false,
});

export function RegionProvider({ children }: { children: React.ReactNode }) {
  const { data: profile, isLoading } = useGetProfile();

  const value = useMemo<RegionContextValue>(() => {
    const p = profile as any;
    const region = p?.region ?? "au";
    return {
      terms: getRegionTerms(region),
      region,
      schoolName: p?.schoolName ?? null,
      reportHeader: p?.reportHeader ?? null,
      reportFooter: p?.reportFooter ?? null,
      dateFormat: p?.dateFormat ?? "dd/MM/yyyy",
      isLoading,
    };
  }, [profile, isLoading]);

  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
}

export function useRegion() {
  return useContext(RegionContext);
}
